import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

function bridgeClient(token) {
  return axios.create({
    baseURL: API_BASE,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
}

async function request(promise) {
  try {
    const res = await promise;
    const body = res?.data;
    if (body?.success === false) {
      const err = new Error(body.message || 'Request failed');
      err.code = body.code;
      err.status = res.status;
      throw err;
    }
    return body?.data ?? body;
  } catch (e) {
    const body = e.response?.data;
    const err = new Error(body?.message || e.message || 'Request failed');
    err.code = body?.code;
    err.status = e.response?.status;
    throw err;
  }
}

export const bridgeAmendmentService = {
  getAmendment: (token) =>
    request(axios.get(`${API_BASE}/bridge/amendment/${encodeURIComponent(token)}`)),

  approveAmendment: (token, body) => {
    const client = bridgeClient(token);
    return request(client.post('/bridge/amendment/approve', body));
  },

  declineAmendment: (token, body) => {
    const client = bridgeClient(token);
    return request(client.post('/bridge/amendment/decline', body));
  },
};

export default bridgeAmendmentService;

function normalizeAmendmentUrl(url) {
  if (!url) return '';
  try {
    const parsed = new URL(url);
    const token = decodeURIComponent(parsed.pathname.replace(/^\/bridge\/amendment\//, ''));
    if (!token) return url;
    return `${window.location.origin}/bridge/amendment/${token}`;
  } catch {
    const match = String(url).match(/\/bridge\/amendment\/([^?#]+)/);
    if (match) return `${window.location.origin}/bridge/amendment/${match[1]}`;
    return url;
  }
}

export { normalizeAmendmentUrl };
